<template>
  <!-- KSK062: platform credit at the foot of every kiosk page. No divider and
       the same white as the bottom bars above it, so it reads as part of that
       bar rather than a footer of its own. `inline` puts it in a layout flow
       (the item customize sheet) instead of fixing it to the screen. -->
  <div class="ksk-powered" :class="{ 'ksk-powered--inline': inline, 'ksk-powered--faded': faded }" aria-label="Powered by MEGAPOS">
    <span class="ksk-powered__by">Powered by</span>
    <img class="ksk-powered__brand" src="/MegaPOSLogo.png" alt="MEGAPOS" draggable="false" />
  </div>
</template>

<script>
export default {
  name: "KskPoweredBy",
  props: {
    inline: { type: Boolean, default: false },
    // KSK067: Landing fades its bottom panel to 70%; the strip matches it.
    faded: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.ksk-powered {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: var(--ksk-powered-height);
  background: var(--ksk-surface);
  font-family: var(--ksk-font);
  pointer-events: none;
  user-select: none;
}
/* KSK069: on Landing the strip's white is 75% transparent (was 95%, then 85%), text stays solid. */
.ksk-powered--faded {
  background: rgba(255, 255, 255, 0.25);
}
@supports (color: color-mix(in srgb, red 50%, blue)) {
  .ksk-powered--faded {
    background: color-mix(in srgb, var(--ksk-surface) 25%, transparent);
  }
}
.ksk-powered--inline {
  position: relative;
  flex: none;
}
/* KSK090: "Powered by" in sentence case. KSK122: MEGAPOS is the logo image. */
.ksk-powered__by {
  font-size: 24px;
  line-height: 30px;
  font-weight: 500;
  color: var(--ksk-text);
}
/* The PNG has wide transparent margins (letters ≈ 42% of its height): 56px
   tall gives ~24px letters; the negative margin offsets its left padding. */
.ksk-powered__brand {
  display: block;
  height: 56px;
  width: auto;
  margin-left: -10px;
}
</style>
